import { createClient, SupabaseClient } from '@supabase/supabase-js';
import axios from 'axios';

let supabaseInstance: SupabaseClient | null = null;

export async function getSupabase(): Promise<SupabaseClient> {
  if (supabaseInstance) return supabaseInstance;

  const { data } = await axios.get<{ supabaseUrl: string; supabaseAnonKey: string }>(
    `${import.meta.env.VITE_API_URL}/auth/oauth-config`,
  );

  supabaseInstance = createClient(data.supabaseUrl, data.supabaseAnonKey);
  return supabaseInstance;
}
